<div class="ds-list">
    <div class="ds-list__item" *ngFor="let item of filesWithName; let i = index">
        <span class="ds-list__item-icon material-icons">picture_as_pdf</span>

        <span class="ds-list__item-label" [title]="item.nombre">{{ item.nombre }}</span>

        <span class="ds-list__item-actions">
            <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                (click)="openDialogPdf(usuario._id, item.adjunto, item.nombre)">
                <span class="material-icons">visibility</span>
                Ver
            </button>
            <button type="button" class="ds-pill ds-pill--primary ds-pill--sm"
                (click)="download(usuario._id, item.adjunto, item.nombre)">
                <span class="material-icons">download</span>
                Descargar
            </button>
        </span>
    </div>

    <div class="ds-alert ds-alert--info" *ngIf="filesWithName.length === 0">
        <span class="material-icons">info</span>
        <div>Sin archivos cargados.</div>
    </div>
</div>
